module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"albumname":"Album name","albumdescription":"Album description","notification":"Notifications","cancel":"Cancel","update":"Update"},"fr":{"albumname":"Nom de l\u0027album","albumdescription":"Description de l\u0027album","notification":"Notifications","cancel":"Annuler","update":"Mettre à jour"}}')
  delete Component.options._Ctor
}
